import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Typography, Tooltip } from "@mui/material";
import { fDateTimeWithTimezone } from "../../../../../utils/formatTime";
import { listItemStyles } from "./orderLogHelper";
import OrderLogItemSubstitution from "./OrderLogItemSubstitution";

OrderLogUpdate.propTypes = {
  logItem: PropTypes.object,
  setHighlightedRow: PropTypes.func,
  orderItem: PropTypes.object,
}

export default function OrderLogUpdate({logItem, setHighlightedRow, orderItem}) {

  const { id = '' } = useParams();
  const { orderById } = useSelector((state) => state.orders);
  const { items = [] } = orderById[id] || {};

  const titleStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
    wordBreak: 'normal',
    cursor: 'pointer' 
  };

  const columnNameLabelMap = {
    "UpdatedQuantity" : "Quantity",
    "PurchasingSubcategory": "Subcategory",
    "PurchasingCategory": "Category",
    "UOMType": "UOM Type",
    "UOMAmount": "UOM Amount",
    "VendorItemId": "SKU",
    "OriginalPrice": "Price",
    "UnitPrice": "Unit Price",
    "Qty": "Quantity",
  };
    
  const descRef = useRef(null);
  const [isDescOverflowing, setIsDescOverflowing] = useState(false);
  const updatedRef = useRef(null);
  const [isUpdatedOverflowing, setIsUpdatedOverflowing] = useState(false);

  useEffect(() => {
    const descEl = descRef.current;
    if (descEl) setIsDescOverflowing(descEl.scrollWidth > descEl.clientWidth);
    const updatedEl = updatedRef.current;
    if (updatedEl) setIsUpdatedOverflowing(updatedEl.scrollWidth > updatedEl.clientWidth);
  }, []);

  return logItem?.columnChanges?.length > 0 && <Box>
      <Box onClick={() => setHighlightedRow(logItem.itemQuantityId)}>
        <Tooltip title={orderItem?.description || ''} disableHoverListener={!isDescOverflowing} placement="top">
          <Typography ref={descRef} variant="body" sx={{...titleStyle, textDecoration: 'underline'}} color="info.main">
            {`${logItem?.tableName === 'ManualItemBudget' ? 'Budget breakdown for' : ''} ${orderItem?.description}`}
          </Typography>
        </Tooltip>
        {logItem.modifiedBy && <Tooltip title={`Updated by ${logItem.modifiedBy}`} disableHoverListener={!isUpdatedOverflowing}>
          <Typography ref={updatedRef} variant="body" sx={titleStyle} color="info.main">
            {`Updated by ${logItem.modifiedBy}`}
          </Typography>
        </Tooltip>}
      </Box>
      <ul style={{ paddingLeft: '20px', margin: 0 }}>
        {logItem?.columnChanges?.map((change, idx) => (
            <li key={idx} style={listItemStyles}>
              <Box>
                {change.columnName === 'PurchasingCategory' && !change.oldValue
                ? `Category "${change.newValue}" added`
                : change.columnName === 'PurchasingSubcategory' && !change.oldValue
                ? `Subcategory "${change.newValue}" added`
                : change.columnName === 'PurchasingCategory' && !change.newValue
                ? `Category "${change.oldValue}" removed`
                : change.columnName === 'PurchasingSubcategory' && !change.newValue
                ? `Subcategory "${change.oldValue}" removed`
                : change.columnName === 'Approved'
                ? `Item ${change.newValue === 'True' ? 'approved' : 'unapproved'}`
                : change.columnName === 'RemoveFromBudget'
                ? `Item ${change.newValue === 'True' ? 'removed from budget' : 'added to budget'}`
                : change.columnName === 'Substitution'
                ? <OrderLogItemSubstitution logItem={logItem} orderItem={orderItem} items={items} setHighlightedRow={setHighlightedRow} change={change} />
                :`${columnNameLabelMap[change.columnName] || change.columnName} changed from "${change.oldValue}" to "${change.newValue}"`}
            </Box>
          </li>
        ))}
      </ul>
      <Typography variant="body2" color="black">
        {fDateTimeWithTimezone(logItem.dateAdded)}
      </Typography>
  </Box>;
}